import { render, staticRenderFns } from "./DunningWaitlistCard.vue?vue&type=template&id=3395e59e&"
import script from "./DunningWaitlistCard.vue?vue&type=script&lang=ts&"
export * from "./DunningWaitlistCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports